import { actions } from './lang/actions'

export default {
    namespaced: true,
    actions
}
